import React, { createContext, useReducer } from "react";

export const SidebarContext = createContext();

const initialState = {
  enabled: false,
  showSearch: false,
};

function reducer(state, action) {
  switch (action.type) {
    case "TOGGLE":
      // console.log("context", action.data)
      return {
        ...state,
        enabled: action.data,
      };
    case "SEARCH_BTN":
      // console.log("context", action.data)
      return {
        ...state,
        showSearch: action.data,
      };
    default:
      return state;
  }
}

export const SidebarProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const value = { state, dispatch };
  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};
